const hiraganasList = [
  {
    cat: 'a',
    kanas: [
      { eng: 'a', jap: 'あ' },
      { eng: 'i', jap: 'い' },
      { eng: 'u', jap: 'う' },
      { eng: 'e', jap: 'え' },
      { eng: 'o', jap: 'お' },
    ],
  },
  {
    cat: 'k',
    kanas: [
      { eng: 'ka', jap: 'か' },
      { eng: 'ki', jap: 'き' },
      { eng: 'ku', jap: 'く' },
      { eng: 'ke', jap: 'け' },
      { eng: 'ko', jap: 'こ' },
    ],
  },
  {
    cat: 's',
    kanas: [
      { eng: 'sa', jap: 'さ' },
      { eng: 'shi', jap: 'し' },
      { eng: 'su', jap: 'す' },
      { eng: 'se', jap: 'せ' },
      { eng: 'so', jap: 'そ' },
    ],
  },
  {
    cat: 't',
    kanas: [
      { eng: 'ta', jap: 'た' },
      { eng: 'chi', jap: 'ち' },
      { eng: 'tsu', jap: 'つ' },
      { eng: 'te', jap: 'て' },
      { eng: 'to', jap: 'と' },
    ],
  },
  {
    cat: 'n',
    kanas: [
      { eng: 'na', jap: 'な' },
      { eng: 'ni', jap: 'に' },
      { eng: 'nu', jap: 'ぬ' },
      { eng: 'ne', jap: 'ね' },
      { eng: 'no', jap: 'の' },
    ],
  },
  {
    cat: 'h',
    kanas: [
      { eng: 'ha', jap: 'は' },
      { eng: 'hi', jap: 'ひ' },
      { eng: 'fu', jap: 'ふ' },
      { eng: 'he', jap: 'へ' },
      { eng: 'ho', jap: 'ほ' },
    ],
  },
  {
    cat: 'm',
    kanas: [
      { eng: 'ma', jap: 'ま' },
      { eng: 'mi', jap: 'み' },
      { eng: 'mu', jap: 'む' },
      { eng: 'me', jap: 'め' },
      { eng: 'mo', jap: 'も' },
    ],
  },
  {
    cat: 'r',
    kanas: [
      { eng: 'ra', jap: 'ら' },
      { eng: 'ri', jap: 'り' },
      { eng: 'ru', jap: 'る' },
      { eng: 're', jap: 'れ' },
      { eng: 'ro', jap: 'ろ' },
    ],
  },
  {
    cat: 'ywn',
    kanas: [
      { eng: 'ya', jap: 'や' },
      { eng: 'yu', jap: 'ゆ' },
      { eng: 'yo', jap: 'よ' },
      { eng: 'wa', jap: 'わ' },
      { eng: 'wo', jap: 'を' },
      { eng: 'n', jap: 'ん' },
    ],
  },
  {
    cat: 'diacritics',
    kanas: [
      { eng: 'ga', jap: 'が' },
      { eng: 'gi', jap: 'ぎ' },
      { eng: 'gu', jap: 'ぐ' },
      { eng: 'ge', jap: 'げ' },
      { eng: 'go', jap: 'ご' },
      { eng: 'za', jap: 'ざ' },
      { eng: 'ji', jap: 'じ' },
      { eng: 'zu', jap: 'ず' },
      { eng: 'ze', jap: 'ぜ' },
      { eng: 'zo', jap: 'ぞ' },
      { eng: 'da', jap: 'だ' },
      { eng: 'di', jap: 'ぢ' },
      { eng: 'du', jap: 'づ' },
      { eng: 'de', jap: 'で' },
      { eng: 'do', jap: 'ど' },
      { eng: 'ba', jap: 'ば' },
      { eng: 'bi', jap: 'び' },
      { eng: 'bu', jap: 'ぶ' },
      { eng: 'be', jap: 'べ' },
      { eng: 'bo', jap: 'ぼ' },
      { eng: 'pa', jap: 'ぱ' },
      { eng: 'pi', jap: 'ぴ' },
      { eng: 'pu', jap: 'ぷ' },
      { eng: 'pe', jap: 'ぺ' },
      { eng: 'po', jap: 'ぽ' },
    ],
  },
  {
    cat: 'yoon',
    kanas: [
      { eng: 'kya', jap: 'きゃ' },
      { eng: 'kyu', jap: 'きゅ' },
      { eng: 'kyo', jap: 'きょ' },
      { eng: 'gya', jap: 'ぎゃ' },
      { eng: 'gyu', jap: 'ぎゅ' },
      { eng: 'gyo', jap: 'ぎょ' },
      { eng: 'sha', jap: 'しゃ' },
      { eng: 'shu', jap: 'しゅ' },
      { eng: 'sho', jap: 'しょ' },
      { eng: 'ja', jap: 'じゃ' },
      { eng: 'ju', jap: 'じゅ' },
      { eng: 'jo', jap: 'じょ' },
      { eng: 'cha', jap: 'ちゃ ' },
      { eng: 'chu', jap: 'ちゅ' },
      { eng: 'cho', jap: 'ちょ' },
      { eng: 'nya', jap: 'にゃ' },
      { eng: 'nyu', jap: 'にゅ' },
      { eng: 'nyo', jap: 'にょ' },
      { eng: 'hya', jap: 'ひゃ' },
      { eng: 'hyu', jap: 'ひゅ' },
      { eng: 'hyo', jap: 'ひょ' },
      { eng: 'bya', jap: 'びゃ' },
      { eng: 'byu', jap: 'びゅ' },
      { eng: 'byo', jap: 'びょ' },
      { eng: 'pya', jap: 'ぴゃ' },
      { eng: 'pyu', jap: 'ぴゅ' },
      { eng: 'pyo', jap: 'ぴょ' },
      { eng: 'mya', jap: 'みゃ' },
      { eng: 'myu', jap: 'みゅ' },
      { eng: 'myo', jap: 'みょ' },
      { eng: 'rya', jap: 'りゃ' },
      { eng: 'ryu', jap: 'りゅ' },
      { eng: 'ryo', jap: 'りょ' },
    ],
  },
];

export default hiraganasList;
